import { createFileRoute } from "@tanstack/react-router";

import OnboardingDocReview from "./-components/OnboardingDocReview";

export const Route = createFileRoute("/_authenticated/onboarding/docs")({
  component: OnboardingDocReview,
  context: () => ({ permissions: "onboarding" }),
});
